import { getDashboardAndWidgets } from '/src/features/dashboards/dashboard/service/dashboard-service';

export const actions = {
  async getDashboardAndWidgets({ commit }, dashboardUUID) {
    commit('setDashboardAndWidgets', {
      dashboardAndWidgets: await getDashboardAndWidgets(dashboardUUID),
      dashboardUUID
    });
  },

  async getCurrentDashboardAndWidgets({ commit }, { dashboardUUID, isEmbedded = false, fromCockpit = false }) {
    const { dashboard: currentDashboard, widgetsByUuid: currentWidgets } = await getDashboardAndWidgets(
      dashboardUUID,
      true,
      fromCockpit,
      isEmbedded
    );
    commit('setCurrentDashboard', { currentDashboard });
    commit('setCurrentWidgets', { currentWidgets });
  }
};
